'use client';

import { format } from 'date-fns';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface IDatePickerWithRange extends React.HTMLAttributes<HTMLDivElement> {
  date?: Date;
  setDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
  calendarProps?: React.ComponentProps<typeof Calendar>;
}

export function DatePicker({
  className,
  date,
  setDate,
  calendarProps,
}: IDatePickerWithRange) {
  return (
    <div className={cn('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <div className="flex flex-row gap-[10px]">
            <Button
              type="button"
              id="date"
              variant={'outline'}
              className={cn('w-full', !date && 'text-muted-foreground')}
            >
              {date ? (
                <>{format(date, 'LLL dd, y')}</>
              ) : (
                <span>Pick a date</span>
              )}
            </Button>
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-auto border-0 p-0" align="start">
          <Calendar
            {...calendarProps}
            initialFocus
            mode="single"
            defaultMonth={new Date()}
            selected={date}
            onSelect={(date) => {
              if (date) {
                const normalized = new Date(date);
                normalized.setHours(12, 0, 0, 0);
                setDate(normalized);
              }
            }}
            disabled={(date) => {
              // Disable all dates in the past
              return date < new Date(new Date().setHours(0, 0, 0, 0));
            }}
            modifiers={{
              disabled: (date) =>
                date < new Date(new Date().setHours(0, 0, 0, 0)),
            }}
            numberOfMonths={1}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
